import checkout from "./form3";

const {
  formField3: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
  },
} = checkout;

const initialValues3 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [supportData.name]: false,
};

export default initialValues3;
